import React from 'react';
import PropTypes from 'prop-types';

const OrientationPrompt = ({ visible }) => {
	if (!visible) {
		return null;
	}

	return (
		<div className="orientation-overlay" role="dialog" aria-modal="true">
			<div className="orientation-graphic">
				<div className="orientation-phone-animator">
					<div className="orientation-phone">
						<div className="orientation-phone-screen" />
					</div>
				</div>
				<p className="orientation-instruction">Please rotate your phone.</p>
			</div>
		</div>
	);
};

OrientationPrompt.propTypes = {
	visible: PropTypes.bool.isRequired,
};

export default OrientationPrompt;
